export const aspectRatios = {
  '1:1': { w: 1, h: 1, label: '1×1' },
  '3:4': { w: 3, h: 4, label: '3×4' },
  '4:3': { w: 4, h: 3, label: '4×3' },
  '16:9': { w: 16, h: 9, label: '16×9' },
  '9:16': { w: 9, h: 16, label: '9×16' },
  '21:9': { w: 21, h: 9, label: '21×9' }
};